import { render, staticRenderFns } from "./unmatched_choose_partner_suprise.vue?vue&type=template&id=8c0c2384&scoped=true&"
import script from "./unmatched_choose_partner_suprise.vue?vue&type=script&lang=js&"
export * from "./unmatched_choose_partner_suprise.vue?vue&type=script&lang=js&"
import style0 from "./unmatched_choose_partner_suprise.vue?vue&type=style&index=0&id=8c0c2384&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0c2384",
  null
  
)

export default component.exports